export const PROJECT_KEY = "PENN_DOT_ICE";
export const NEW_PROJECT_KEY = "NEW_PROJECT_PENN_DOT_ICE";
export const HAS_SEEN_CAPX_DISCLAIMER = "HAS_SEEN_CAPX_DISCLAIMER";

// see https://github.com/kittelson/penn-dot-ice/wiki/Project-Data-Shape
// for a description of the shape of the project data
export const STEP_STORAGE_KEYS = {
  COST_PARAMETERS_DEFAULTS: "costParametersDefaults",
  PROJECT_INFORMATION: "projectInfo",
  GLOBAL_INPUT_DATA: "globalInputData",
  GLOBAL_SAFETY_DATA: "globalSafetyData",
  TRAFFIC_VOLUMES: "trafficVolumes",
  INTERSECTIONS: "intersections",
  CRASH_MODIFICATION_FACTORS: "crashModificationFactors",
  OUTPUTS: "outputs",
};

export const TRAFFIC_VOLUME_KEYS = {
  VOLUME_ADJUSTMENT_FACTORS: "volumeAdjustmentFactors",
  DEFAULT_DEMAND_PROFILES: "defaultDemandProfiles",
  OPENING_YEAR: "openingYear",
  DESIGN_YEAR: "designYear",
};

export const VOLUME_SCENARIOS = {
  OPENING_YEAR_AM_PEAK: `${TRAFFIC_VOLUME_KEYS.OPENING_YEAR}.amPeak`,
  OPENING_YEAR_PM_PEAK: `${TRAFFIC_VOLUME_KEYS.OPENING_YEAR}.pmPeak`,
  OPENING_YEAR_WEEKEND_PEAK: `${TRAFFIC_VOLUME_KEYS.OPENING_YEAR}.weekendPeak`,
  DESIGN_YEAR_AM_PEAK: `${TRAFFIC_VOLUME_KEYS.DESIGN_YEAR}.amPeak`,
  DESIGN_YEAR_PM_PEAK: `${TRAFFIC_VOLUME_KEYS.DESIGN_YEAR}.pmPeak`,
  DESIGN_YEAR_WEEKEND_PEAK: `${TRAFFIC_VOLUME_KEYS.DESIGN_YEAR}.weekendPeak`,
};
export const VOLUME_SCENARIOS_ORDER = Object.values(VOLUME_SCENARIOS);

export const VOLUME_SCENARIOS_ORDER_WEEKDAY_ONLY = [
  VOLUME_SCENARIOS.OPENING_YEAR_AM_PEAK,
  VOLUME_SCENARIOS.OPENING_YEAR_PM_PEAK,
  VOLUME_SCENARIOS.DESIGN_YEAR_AM_PEAK,
  VOLUME_SCENARIOS.DESIGN_YEAR_PM_PEAK,
];

export const REQUIRED_VOLUME_SCENARIOS = [
  VOLUME_SCENARIOS.OPENING_YEAR_AM_PEAK,
  VOLUME_SCENARIOS.OPENING_YEAR_PM_PEAK,
  VOLUME_SCENARIOS.OPENING_YEAR_WEEKEND_PEAK,
  VOLUME_SCENARIOS.DESIGN_YEAR_AM_PEAK,
  VOLUME_SCENARIOS.DESIGN_YEAR_PM_PEAK,
  VOLUME_SCENARIOS.DESIGN_YEAR_WEEKEND_PEAK,
];

export const INTERSECTION_NUMBERS = {
  INTERSECTION_1: "intersection1",
  INTERSECTION_2: "intersection2",
};

export const DEMAND_PROFILES_KEYS = {
  DEMAND_VOLUME: "demandVolume",
  PARAMETERS: "parameters",
};

export const EVALUATION_TYPES = {
  CAP_X: "CAP_X",
  LIFE_CYCLE_COST: "LIFE_CYCLE_COST",
};

export const DEMAND_PROFILES_PARAM_KEYS = {
  DAILY: "daily",
  MONTHLY: "monthly",
  HOURLY_WEEKDAY: "hourlyWeekday",
  HOURLY_WEEKEND: "hourlyWeekend",
};

export const COST_PARAMETERS_STORAGE_KEYS = {
  COST_PARAMETERS: "costParameters",
  DISCOUNT_RATE: "discountRate",
  VALUE_OF_TIME: "valueOfTime",
  COST_PER_CRASH: "costPerCrash",
  OPERATIONS_AND_MAINTENANCE: "operationsAndMaintenance",
};
